// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"73":"76fac494","86":"fe934dad","160":"d3eb0d2e","220":"e92744ca","972":"ca3ebe3e","999":"35518e5e"}[chunkId] + ".chunk.css";
};